export default {
  OK: 0,
  OK200: 200,
  BIND_CODE: [10002],
  GROUP_CODE: [40002, 601, 41001]
}



// WEBPACK FOOTER //
// ./src/constants/res-code.js